export default __webpack_public_path__ + "static/media/bq-bo.55a37114.svg";